import { IResponseComboItem } from '~/types/combo';
import { IResponseProductSize } from '~/types/products';

export const isCorrectMealSize = (items: IResponseComboItem[] | undefined, size: IResponseProductSize | null): boolean => {
  return Boolean(items?.some((item) => item.size_id === size?.id));
};
